
import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

// Services
import { SharedService } from 'src/app/services/shared.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ProfileService } from 'src/app/services/profile/profile.service';

import { Address } from 'src/app/models/address';

// Maps
import { } from 'googlemaps';
import toastr from "toastr";

@Component({
    selector: 'app-login-without-address',
    templateUrl: './login-without-address.component.html',
    styleUrls: ['./login-without-address.component.sass'],
    standalone: false
})
export class LoginWithoutAddressComponent implements OnInit {

  showLogin: boolean = false;

  optionsMap: any;
  mapLocation: any;
  markerLocation: any;
  geocoder: any;
  latitude: number = 4.6097100;
  longitude: number = -74.0817500;

  listIndicatives: any[];
  indicativeSelected: string = '57';
  statusSelectIndicative: boolean = false;

  numberPhone: string = '';
  phoneValid: boolean = false;

  optSelected: number = 1;

  // codigo
  code1: string = '';
  code2: string = '';
  code3: string = '';
  code4: string = '';
  code5: string = '';
  codeValid: number = 1; // 1: invalid, 2: valid, 3: loading 
  resendCode: number = 60;

  loading: boolean = false;

  // direcciones
  listAddress: Address[] = [];
  addressSearch: string = '';
  nameAddress: string = '';
  descriptionAddress: string = '';

  // Registro
  userName: string = '';

  constructor(
    private _sharedService: SharedService,
    private _loginService: LoginService,
    private _profileService: ProfileService
  ) {
    this.listIndicatives = this._sharedService.getListIndicatives();
    this.optionsMap = this._sharedService.getoptionsMap();
  }

  ngOnInit(): void {
    
  }

  selectOpt(opt: number): void {
    this.optSelected = opt;
    switch(opt){
      case 4:{
        
        break;
      }
    }
  }



  // Login
  showIndicatives(): void {
    let widthContainer = document.getElementsByClassName('container-input-indicative')[0].clientWidth;
    let list: any =  document.getElementsByClassName('list-indicatives')[0];
    list.style.width = widthContainer + 'px';
    this.statusSelectIndicative = true;
  }

  selectIndicative(indicative: string): void{
    this.indicativeSelected = indicative;
    this.statusSelectIndicative = false;
  }

  validateOnlyNumbers(): void {
    if(
      this._sharedService.validateOnlyNumbers(this.numberPhone) &&
      this.numberPhone.length > 7
      ){
      this.phoneValid = true;
    }else this.phoneValid = false;
    
  }

  async login() {
    this.codeValid = 3;
    let data = {
      phone_code: '+' + this.indicativeSelected,
      user: this.numberPhone,
      password: `${this.code1}${this.code2}${this.code3}${this.code4}${this.code5}`
    };
    let response: any = await this._loginService.loginUser(data).toPromise()
    .catch((err: any) => {
      this.codeValid = 3;
      console.log('Error de login: ', err);
      if(err.error.message) toastr.warning(err.error.message);
    });
    if( response && response.data && response.data.session ){
      console.log(response);
      localStorage.setItem('uid',response.data.session.user_id)
      localStorage.setItem('token',response.data.session.token)
      localStorage.setItem('session','true')
      this._loginService.emmiterLoginSuccess(true);
      this._loginService.emmiterShowLogin(false);
      this.codeValid = 3;
    }
  }

  // Registro
  async getCode() {
    this.loading = true;
    let data = {
      phone_code: '+' + this.indicativeSelected,
      user: this.numberPhone
    };
    let response: any = await this._loginService.getCode(data).toPromise().catch((err: any) => this.handleError(err));
    if( response ){
      console.log(response);
      this.optSelected = 3;
      this.loading = false;
      this.countdown();
    }
  }
  
  handleError(error: HttpErrorResponse): void {
    if(error.error.message) console.log(error.error.message);
    if(error.status == 404) this.selectOpt(2);
    this.loading = false;
  }
  
  async registerUser() {
    console.log('registrando');
    if(this.userName != ''){
      this.loading = true;
      let data = {
        phone_code: '+' + this.indicativeSelected,
        phone: this.numberPhone,
        name: this.userName
      };
      let response: any = await this._loginService.registerUser(data).toPromise()
      .catch((err: any) => console.log('Error al registrar', err));
      if( response ){
        this.loading = false;
        this.getCode();
      }
    } else toastr.warning('Ingrese un nombre valido');
  }


  // Codigo
  changeCode(): void {
    this.code1 = this.code1.substr(0,1);
    this.code2 = this.code2.substr(0,1);
    this.code3 = this.code3.substr(0,1);
    this.code4 = this.code4.substr(0,1);
    this.code5 = this.code5.substr(0,1);
    if(this.code1 != '' && this.code2 != '' && this.code3 != '' && this.code4 != '' && this.code5 != '' ) this.codeValid = 2;
    else this.codeValid = 1;
  }

  keyUp(id ?: any): void {

    this.code1 = this.code1.substr(0,1);
    this.code2 = this.code2.substr(0,1);
    this.code3 = this.code3.substr(0,1);
    this.code4 = this.code4.substr(0,1);
    this.code5 = this.code5.substr(0,1);

    if(this.code1 != '' && this.code2 != '' && this.code3 != '' && this.code4 != '' && this.code5 != '' ) this.codeValid = 2;
    else this.codeValid = 1;

    let inputCodeSix = (document.getElementById('code5') as HTMLInputElement);
    if(id == null || id == undefined){
      if(inputCodeSix.value.length > 1 ) inputCodeSix.value = inputCodeSix.value.charAt(1);
    }else{
      (document.getElementById(id) as HTMLInputElement).select();
      (document.getElementById(id) as HTMLInputElement).focus();
    }
  }

  countdown(): void {
    this.resendCode = 60;
    let interval = setInterval(() => {
      this.resendCode --;
      if(this.resendCode == 0) clearInterval(interval);
    } , 1000);
  }

  closeLogin(): void {
    this._loginService.emmiterShowLogin(false);
  }

}
